export const directions = {
    UP: -1,
    LEFT: -1,
    DOWN: 1,
    RIGHT: 1,
} as const;

export type direction = typeof directions[keyof typeof directions];